import { api } from './api';

/**
 * Contacts API service for handling contact form submissions
 * Supports FormData for file uploads
 */
export const contactsApi = api.injectEndpoints({
  reducerPath: 'contactsApi',
  endpoints: (builder) => ({
    submitContactForm: builder.mutation({
      query: ({ formType, formData, language }) => {
        // Create FormData if not already FormData
        const data = formData instanceof FormData 
          ? formData 
          : (() => {
              const fd = new FormData();
              Object.entries(formData).forEach(([key, val]) => {
                fd.append(key, val);
              });
              return fd;
            })();

        return {
          url: `contacts/${formType}_form`,
          method: 'POST',
          body: data,
          // RTK Query's fetchBaseQuery automatically handles FormData
          // It won't set Content-Type if body is FormData, allowing browser to set it with boundary
          // Headers are merged with prepareHeaders from authBaseQuery
          headers: {
            'Accept-Language': language,
          },
        };
      },
    }),
  }),
});

export const { useSubmitContactFormMutation } = contactsApi;
